// extracted by mini-css-extract-plugin
module.exports = {"FreeRun":"FreeRun_FreeRun__3dUc7","FormStyle":"FreeRun_FormStyle__ssRRw","titles":"FreeRun_titles__MVxc4","Note":"FreeRun_Note__4kuP7","smallText":"FreeRun_smallText__31mVs"};